// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addresearcherdialog_featuredItem__cBWKG {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.addresearcherdialog_featuredTitleHeader__vHqyy {
    font-size: 16px;
    font-weight: bold;
    color: #133454;
}

.addresearcherdialog_dialogInputs__H20Sd {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/components/UserManagement/AddResearcherDialog/addresearcherdialog.module.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.featuredTitleHeader {\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    color: #133454;\r\n}\r\n\r\n.dialogInputs {\r\n    width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featuredItem": `addresearcherdialog_featuredItem__cBWKG`,
	"featuredTitleHeader": `addresearcherdialog_featuredTitleHeader__vHqyy`,
	"dialogInputs": `addresearcherdialog_dialogInputs__H20Sd`
};
export default ___CSS_LOADER_EXPORT___;
